import {Favorites, About} from "../../components"
import SliderComponent from "../../components/Slider";
import SliderMenuComponent from "../../components/SliderMenu";
import {toast} from "react-toastify";
import AwardBadge from "../../components/Badge";

const Home = () => {
    return (
        <div className='flex w-full h-auto flex-col items-center justify-center'>
            <SliderComponent/>
            <About/>
            <SliderMenuComponent/>
            <Favorites/>
        </div>

    )
}

export default Home